/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ProStatus {
    NONE = 'NONE',
    PENDING = 'PENDING',
    VERIFIED = 'VERIFIED',
    REFUSED = 'REFUSED',
}
